import { Task } from '@amzn/taskscheduling-service';

export type TaskWithStatus = Task & { status?: string };
